import React, { useState, useEffect } from 'react';
import Breadcrumb from '../../components/navigation/breadcrumb';
import apiConfig from '../../common/config/api.config';
import adeccoHeader from "../../media/header/adecco_kunden.png";
import disHeader from "../../media/header/dis_kunden.png";
import akkodisHeader from "../../media/header/akkodis_kunden.png";
import proservHeader from "../../media/header/proserv_kunden.png";
import aghHeader from "../../media/header/agh_kunden.png";
import absWillkommen from "../../media/header/abs_willkommen.png";
import infoIcon from "../../media/icons/info_icon_landingpage.png";
import Axios from 'axios';

export interface Props {
    title: string;
    text: string;
    brand: string;
    eu: boolean | string;
}

const ContentPage = (props: Props) => {
    const [videoUrl, setVideoUrl] = useState<string | null>(null);
    const [aktiverText, setAktiverText] = useState<string>("");
    const [error, setError] = useState<string | null>(null);
    const [loading, setLoading] = useState<boolean>(true);
    const documentNameAGH = 'Adecco-Lohnabrechnung.mp4';
    const documentNameDIS = 'DISAG_Akkodis-Lohnabrechnung.mp4';
    const documentNameDISstatic = 'DISAG_Gehaltsumbau.mp4';


    const key = localStorage.getItem('key');
    const filter = String(localStorage.getItem("filter"));
    const design = props.brand;

    useEffect(() => {
        const fetchVideoUrl = async () => {
            if (!key) {
                setError('Kein gültiger Schlüssel gefunden. Bitte melden Sie sich erneut an.');
                setLoading(false);
                return;
            }
            if (filter == "k")
                setAktiverText("");
            else
                setAktiverText(props.text);

            try {

                if (props.brand == "disstatic") {
                    const response = await Axios.get(`${apiConfig().url}Documents/GetVideoUrl/${documentNameDISstatic}?key=${encodeURIComponent(key)}`);
                    setVideoUrl(response.data.url);
                }
                else
                    if (props.brand == "dis" || props.brand == "akkodis") {
                        const response = await Axios.get(`${apiConfig().url}Documents/GetVideoUrl/${documentNameDIS}?key=${encodeURIComponent(key)}`);
                        setVideoUrl(response.data.url);
                    }

                    else {
                        const response = await Axios.get(`${apiConfig().url}Documents/GetVideoUrl/${documentNameAGH}?key=${encodeURIComponent(key)}`);
                        setVideoUrl(response.data.url);

                    }
            } catch (err) {
                setError('Fehler beim Abrufen der Video-URL.');
                console.error(err);
            } finally {
                setLoading(false);
            }
        };

        fetchVideoUrl();
    }, [documentNameDIS, documentNameAGH, key]);

    return (
        <div className="content d-flex flex-column flex-column-fluid">
            <Breadcrumb title={props.title} text={design != "disstatic" ? aktiverText : ""}></Breadcrumb>
            {!loading && props.brand == 'abs' && filter == "p" && (
                <div>
                    <div
                        style={{
                            display: "flex",
                            gap: "10px",
                            marginBottom: "20px",
                            alignItems: "stretch",
                            flexWrap: "wrap",
                            paddingLeft: "10px",
                            paddingRight: "10px"
                        }}
                    >
                        {/* Bild */}
                        <img
                            src={absWillkommen}
                            alt="Einstieg ABS Group"
                            style={{
                                width: "100%",
                                maxWidth: "380px",
                                objectFit: "cover",
                                display: "block",
                                flex: "1 1 320px",
                            }}
                        />

                        {/* Text-Kasten */}
                        <div
                            style={{
                                backgroundColor: "#ffffff",
                                padding: "24px",
                                display: "flex",
                                flexDirection: "column",
                                justifyContent: "center",
                                flex: "1 1 320px",
                                minWidth: "0",
                            }}
                        >
                            <h2>Dein Einstieg bei der ABS Group</h2>

                            <p>Schön, dass du deinen Weg zu uns gefunden hast.</p>

                            <p>
                                In diesem Portal findest du alle Unterlagen, die für deinen Start
                                bei der ABS Group wichtig sind.
                            </p>

                            <p>
                                Die Dokumente stehen dir übersichtlich zur Verfügung und können
                                jederzeit eingesehen oder heruntergeladen werden.
                            </p>
                        </div>
                    </div>
                    {/* Hinweis-Balken */}
                    <div
                        style={{
                            margin: "0 10px",
                            backgroundColor: "#ffffff",
                            padding: "14px 18px",
                            display: "flex",
                            alignItems: "center",
                            borderRadius: "4px",
                            marginBottom: "30px",
                        }}
                    >
                        <img
                            src={infoIcon}
                            alt="Info"
                            style={{
                                width: "18px",
                                height: "18px",
                                marginRight: "10px",
                            }}
                        />
                        <span>
                            Bei Fragen oder wenn dir etwas fehlt, melde dich gern bei deiner
                            Ansprechperson.
                        </span>
                    </div>
                    <div
                        style={{
                            display: "flex",
                            gap: "30px",
                            marginTop: "20px",
                            paddingLeft: "10px",
                            paddingRight: "10px"
                        }}
                    >
                        {/* Kachel 1 */}
                        <div
                            style={{
                                backgroundColor: "#ffffff",
                                padding: "24px",
                                width: "50%",
                                borderRadius: "4px",
                            }}
                        >
                            <h2>Faire Integration</h2>

                            <p>
                                Das Beratungsangebot „Faire Integration“ unterstützt Beschäftigte
                                aus dem Ausland bei Fragen zu ihren Arbeitsrechten in Deutschland.
                                Hier findest du Informationen und Unterstützung bei Problemen im
                                Arbeitsverhältnis.
                            </p>

                            <a
                                href="https://www.bmas.de/DE/Arbeit/Arbeitsrecht/Arbeitnehmerrechte/Beratungsangebot-Faire-Integration/beratungsangebot-faire-integration.html"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                Informationen öffnen
                            </a>
                        </div>

                        {/* Kachel 2 */}
                        <div
                            style={{
                                backgroundColor: "#ffffff",
                                padding: "24px",
                                width: "50%",
                                borderRadius: "4px",
                            }}
                        >
                            <h2>Faire Mobilität</h2>

                            <p>
                                Das Informationsangebot „Faire Mobilität“ des Bundesministeriums für
                                Arbeit und Soziales richtet sich an Beschäftigte aus anderen
                                EU-Ländern und informiert über faire Arbeitsbedingungen und Rechte
                                in Deutschland.
                            </p>

                            <a
                                href="https://www.bmas.de/DE/Europa-und-die-Welt/Europa/Arbeiten-innerhalb-der-EU/Faire-Mobilitaet/faire-mobilitaet.html"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                Informationen öffnen
                            </a>
                        </div>
                    </div>
                </div>

            )}
            <div className="d-flex flex-column-fluid">

                <div >

                    <div className="row">
                        {error && (
                            <div className="col-md-12">
                                <p>{error}</p>
                            </div>
                        )}
                        {loading && (
                            <div className="col-md-12">
                                <p>Seite wird geladen...</p>
                            </div>
                        )}

                        {!loading && props.eu == "false" && props.brand != 'abs' && filter == "p" && (
                            <div style={{
                                marginLeft: "20px",
                                backgroundColor: "#ffffff",
                                padding: "24px",
                                display: "flex",
                                flexDirection: "column",
                                justifyContent: "center",
                                width: "360px",
                            }}>
                                <div><h1><b>Informationspflichten Aufenthaltsgesetz</b></h1></div>
                                <div>Beachten Sie bitte diese Wichtige Information</div>
                                <a href='https://www.bmas.de/DE/Arbeit/Arbeitsrecht/Arbeitnehmerrechte/Beratungsangebot-Faire-Integration/beratungsangebot-faire-integration.html' target='_blank'>Bitte lesen!</a>
                            </div>
                        )}
                        {!loading && props.eu == "true" && props.brand != 'abs' && filter == "p" && (
                            <div style={{
                                marginLeft: "20px",
                                backgroundColor: "#ffffff",
                                padding: "24px",
                                display: "flex",
                                flexDirection: "column",
                                justifyContent: "center",
                                width: "360px",
                            }}>
                                <div><h1><b>Faire Mobilität - BMAS</b></h1></div>
                                <div>Hier geht es um ein Beratungs- und Informationsangebot auf Grundlage des Arbeitnehmer-Entsendegesetzes (AentG) „Faire Mobilität“ gem. des Bundesministeriums für Arbeit und Soziales.</div>
                                <a href='https://eur02.safelinks.protection.outlook.com/?url=https%3A%2F%2Fwww.bmas.de%2FDE%2FEuropa-und-die-Welt%2FEuropa%2FArbeiten-innerhalb-der-EU%2FFaire-Mobilitaet%2Ffaire-mobilitaet.html&data=05%7C02%7CAdo.Becher%40adeccogroup.com%7Ce206c934189b45f771c608de68a67a5a%7Cf30ac191b8b445f29a9be5466cb90c2f%7C0%7C0%7C639063261401545937%7CUnknown%7CTWFpbGZsb3d8eyJFbXB0eU1hcGkiOnRydWUsIlYiOiIwLjAuMDAwMCIsIlAiOiJXaW4zMiIsIkFOIjoiTWFpbCIsIldUIjoyfQ%3D%3D%7C0%7C%7C%7C&sdata=y9MkSaC%2FbMLYTBXNcwqj18VeH2ubWHMv40i%2BWqjAPyg%3D&reserved=0' target='_blank'>hier klicken zum lesen</a>
                            </div>
                        )}
                        {!loading && videoUrl && filter == "p" && props.brand != 'abs' && (
                            <div className="col-md-4">
                                <div className="video-tile">
                                    <video width="100%" height="auto" controls>
                                        <source src={videoUrl} type="video/mp4" />
                                        Ihr Browser unterstützt das Video-Tag nicht.
                                    </video>
                                    <div className="video-description">
                                        {design == "disstatic" && <h5>Erklärvideo Gehaltsumbau</h5>}
                                        {design != "disstatic" && <h5>Erklärvideo Lohnabrechnung</h5>}
                                        <p></p>
                                    </div>
                                </div>
                            </div>
                        )}

                        {/* Weitere Inhalte */}
                        {!loading && videoUrl && filter == "k" && (
                            <div style={{ fontSize: 16.25 }} className="col-md-4">
                                {props.brand == "dis" && (<img src={disHeader} />)}
                                {props.brand == "adecco" && (<img src={adeccoHeader} />)}
                                {props.brand == "akkodis" && (<img src={akkodisHeader} />)}
                                {props.brand == "proserv" && (<img src={proservHeader} />)}
                                {props.brand == "aghplus" && (<img src={aghHeader} />)}
                                <br></br>
                                <br></br>
                                <p style={{ width: "960px" }}><b>in unserem Kunden-Hub finden Sie alle Dokumente, die für unsere Zusammenarbeit, eine vertrauensvolle Geschäftsbeziehung sowie für Ihre Sicherheit und Compliance, erforderlich sind.</b></p>

                                <p style={{ width: "960px" }}><b>Übrigens, wussten Sie, dass es bei der Adecco Group in rund 60 Jahren Personaldienstleistungen am Markt, noch keinen Fall der Subsidiärhaftung gegeben hat?</b></p>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ContentPage;
